const defaultParams = {
  offset: 0,
  includeNonPurchasableTypes: "restocking",
};

const mergeDefaultParams = (params) => ({ ...defaultParams, ...params });

export default mergeDefaultParams;
